import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { Heading } from '@chakra-ui/react';

/**
 * Heading - h3
 *
 * @see Docs https://chakra-ui.com/heading
 */
var HeadingH3 = function HeadingH3(props) {
  return /*#__PURE__*/React__default.createElement(Heading, _extends({
    as: "h3",
    size: "h3"
  }, props));
};
export { HeadingH3 };